import { Spinner } from '@cimplico/components';
import { useEntityTaxRates } from '../../../../queries/use-entity-tax-rates';
import { Entity } from '../../../../types/entity';
import EntityTaxRates from './tax-rates/EntityTaxRates';
import ErrorSplashScreen from '../../../../pages/ErrorSplashScreen';
import EntityDetails from './details/EntityDetails';

type EntityOverviewSettingsProps = {
    entity: Entity;
    connectedToXero: boolean;
    onXeroError: (error?: { name: string; message: string }) => void;
};

function EntityOverviewSettings({ entity, connectedToXero, onXeroError }: EntityOverviewSettingsProps): JSX.Element {
    const entityTaxRatesQuery = useEntityTaxRates(entity.id);

    if (entityTaxRatesQuery.isLoading) {
        return (
            <div className="absolute w-full h-[calc(100vh-56px)]">
                <div className="absolute top-1/3 left-1/2">
                    <Spinner />
                </div>
            </div>
        );
    }
    if (entityTaxRatesQuery.isError || !entityTaxRatesQuery.isSuccess) {
        return <ErrorSplashScreen title="An error has occurred." />;
    }

    const entityTaxRates = entityTaxRatesQuery.data?.entityTaxRates || [];

    return (
        <div className="grid gap-y-4">
            <EntityDetails entity={entity} />
            <EntityTaxRates
                taxRates={entityTaxRates}
                connectedToXero={connectedToXero}
                entityId={entity.id}
                onXeroError={onXeroError}
                isEditable={!entity.isArchived}
                lastRefreshed={entity.integrations.xero?.taxRatesRefreshedAt || undefined}
            />
        </div>
    );
}

export default EntityOverviewSettings;
